import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { ClinButton } from '../../components/ClinButton'
import { mediaQueryDown, mediaQuery } from '../../utils/mediaQuery'
import { ClinText } from '../../components/ClinText'
import { IClinTextProps } from '../../components/ClinText/ClinText'

const mobileUpBreakpoint = ClinTheme.breakpoints[0]
const tabletUpBreakpoint = ClinTheme.breakpoints[1]
const desctopUpBreakpoint = ClinTheme.breakpoints[2]

interface IStyledIconProps {
  height?: number
  width?: number
  isPositioned?: boolean
}

export const StyledIcon = styled.img<IStyledIconProps>`
  ${mediaQueryDown(mobileUpBreakpoint)} {
    display: none;

    &.lightening-icon {
      display: unset !important;
      top: unset !important;
      right: unset !important;
      height: 31px;
      position: absolute !important;
      margin: 10px 0 0 3px;
    }
  }
`

export const StyledPageHeader = styled.header({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  textAlign: 'center',
  padding: `${ClinTheme.space[5]}px`,

  h1: {
    fontFamily: 'CabinetGrotesk-Extrabold, sans-serif',
    fontWeight: ClinTheme.fontWeights.bolder
  },

  [mediaQueryDown(mobileUpBreakpoint)]: {
    padding: `${ClinTheme.space[4]}px ${ClinTheme.space[3]}px`,
    div: {
      flexDirection: 'row'
    },
    '.clin-text': {
      textAlign: 'center'
    }
  }
})

export const StyledClinButton = styled(ClinButton)({
  textTransform: 'none',
  width: '258px',
  height: '48px',
  color: '#270072',
  ':hover': {
    color: ClinTheme.colors.white
  },

  [mediaQueryDown(mobileUpBreakpoint)]: {
    width: '100%',
    maxWidth: '258px',
    margin: `${ClinTheme.space[2]}px 0`
  }
})

export const StyledWelcomeContainer = styled.div({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: `${ClinTheme.space[4]}px ${ClinTheme.space[3]}px`,

  [mediaQuery(tabletUpBreakpoint)]: {
    minHeight: 'auto',
    padding: 0
  }
})

export const StyledSearchContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  margin: `${ClinTheme.space[5]}px 0`,
  width: '100%',

  '.autosuggest': {
    width: '100%',
    maxWidth: '1105px'
  },

  [mediaQueryDown(mobileUpBreakpoint)]: {
    margin: `${ClinTheme.space[4]}px 0`
  }
})

export const StyledHomeContainer = styled.div({
  backgroundColor: ClinTheme.colors.lightGrey
})

export const StyledContainer = styled.div({
  [mediaQueryDown(mobileUpBreakpoint)]: {
    '.clin-spacer-recent-searches': {
      height: '30px'
    }
  }
})

export const StyledButtonRow = styled.div({
  display: 'flex',
  justifyContent: 'center',
  gap: `${ClinTheme.space[4]}px`,
  flexWrap: 'wrap',
  width: '100%',

  [mediaQueryDown(mobileUpBreakpoint)]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: `${ClinTheme.space[3]}px`
  }
})

export const StyledSearchIcon = styled.span({
  display: 'inline',
  [mediaQueryDown(mobileUpBreakpoint)]: {
    display: 'none'
  }
})

export const StyledRecentSearches = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: `-${ClinTheme.space[6]}px`,
  marginBottom: ClinTheme.space[9],
  width: '100%',
  gap: `${ClinTheme.space[2]}px`,

  '.recent-searches-row': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: `${ClinTheme.space[3]}px`,
    flexWrap: 'wrap',
    justifyContent: 'center'
  },

  '.first-line': {
    display: 'flex',
    alignItems: 'center',
    gap: `${ClinTheme.space[2]}px`,
    flexWrap: 'wrap',
    justifyContent: 'center'
  },

  '.button-text': {
    display: 'inline-block',
    padding: `${ClinTheme.space[2]}px ${ClinTheme.space[4]}px`,
    borderRadius: `${ClinTheme.space[4]}px`,
    color: ClinTheme.colors.primaryLight,
    backgroundColor: ClinTheme.colors.white,
    textAlign: 'center',
    fontSize: ClinTheme.fontSizes[2],
    fontWeight: ClinTheme.fontWeights.medium,
    lineHeight: ClinTheme.lineHeights.body,
    cursor: 'pointer',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '90%'
  },

  [mediaQueryDown(mobileUpBreakpoint)]: {
    padding: 0,

    '.recent-searches-row': {
      flexDirection: 'column',
      alignItems: 'center',
      gap: `${ClinTheme.space[2]}px`,
      width: '100%'
    },

    '.first-line': {
      flexDirection: 'column',
      alignItems: 'center',
      gap: `${ClinTheme.space[2]}px`,
      width: '100%'
    },

    '.button-text': {
      width: '100%',
      maxWidth: '280px',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'break-word'
    }
  }
})

export const StyledRecentSearchesLabel = styled.p({
  margin: 0,
  fontSize: ClinTheme.fontSizes[2],
  color: ClinTheme.colors.black,
  fontWeight: ClinTheme.fontWeights.normal
})

export const StyledButtonRecentSearches = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: `${ClinTheme.space[2]}px`,

  '.first-line': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: `${ClinTheme.space[2]}px`,
    flexWrap: 'nowrap'
  },

  '.second-line': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: `${ClinTheme.space[2]}px`,
    flexWrap: 'nowrap'
  },

  '.button-text': {
    display: 'inline-block',
    padding: `${ClinTheme.space[2]}px ${ClinTheme.space[4]}px`,
    borderRadius: `${ClinTheme.space[4]}px`,
    color: ClinTheme.colors.primaryLight,
    backgroundColor: ClinTheme.colors.white,
    textAlign: 'center',
    fontSize: ClinTheme.fontSizes[2],
    fontWeight: ClinTheme.fontWeights.medium,
    lineHeight: ClinTheme.lineHeights.body,
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  },

  [mediaQueryDown(mobileUpBreakpoint)]: {
    '.first-line, .second-line': {
      flexWrap: 'wrap',
      justifyContent: 'center'
    },

    '.button-text': {
      width: 'auto',
      maxWidth: '100%'
    }
  }
})

export const StyledNotFound = styled.div({
  backgroundColor: ClinTheme.colors.white,
  boxShadow: ClinTheme.shadows[4],
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  maxWidth: ClinTheme.containerWidths[3],
  alignItems: 'center',
  margin: '0 auto',
  borderRadius: `${ClinTheme.space[2]}px`,
  boxSizing: `border-box`,
  marginTop: '-56px',

  [mediaQueryDown(desctopUpBreakpoint)]: {
    width: 'calc(100% - 40px)',
    maxWidth: 'calc(100% - 40px)'
  },

  [mediaQueryDown(mobileUpBreakpoint)]: {
    marginTop: '-24px'
  }
})

export const StyledNotFoundContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '640px',
  alignItems: 'center',
  margin: '0 auto',
  padding: `${ClinTheme.space[5]}px`,
  gap: `${ClinTheme.space[2]}px`,
  boxSizing: 'border-box'
})

export const StyledTitleRow = styled.div({
  display: 'flex',
  gap: `${ClinTheme.space[2]}px`,
  flexWrap: 'wrap',
  justifyContent: 'center',
  textAlign: 'center',

  [mediaQueryDown(mobileUpBreakpoint)]: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: `${ClinTheme.space[1]}px`
  }
})

export const StyledTitle = styled(ClinText)<IClinTextProps>({
  fontSize: ClinTheme.fontSizes[4],
  lineHeight: ClinTheme.lineHeights.heading[1],
  fontWeight: ClinTheme.fontWeights.medium,
  margin: 0,
  wordBreak: 'break-word',
  overflowWrap: 'break-word',

  [mediaQueryDown(mobileUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[3]
  }
})

export const StyledTitleValue = styled(ClinText)<IClinTextProps>({
  fontSize: ClinTheme.fontSizes[4],
  lineHeight: ClinTheme.lineHeights.heading[1],
  fontWeight: ClinTheme.fontWeights.bold,
  margin: 0,
  wordBreak: 'break-word',
  overflowWrap: 'break-word',

  [mediaQueryDown(mobileUpBreakpoint)]: {
    fontSize: ClinTheme.fontSizes[3]
  }
})

export const StyledDescription = styled(ClinText)<IClinTextProps>({
  fontSize: ClinTheme.fontSizes[2],
  lineHeight: ClinTheme.lineHeights.body,
  textAlign: 'center',
  marginBottom: `${ClinTheme.space[3]}px`
})

export const StyledNotFoundButton = styled(ClinButton)({
  color: ClinTheme.colors.primary,
  ':hover': {
    color: ClinTheme.colors.white
  }
})
